module.exports = __webpack_public_path__ + "media/customizations/teravalis/logo-811b6d2d588e74088b53b7b44ac0db46.png";